module.exports = __webpack_public_path__ + "img/document.ff064987.svg";